import { CLOUDFLARE_CLIENT_ACCESS_URL } from '~/constants/urls'
import { useClientAccessStore } from '~/stores/clientAccessStore'
import ICloudflareTrace from '~/types/common/client-access'

export default function useAccessClientInfo() {
  const { setClientAccessInfo } = useClientAccessStore()

  const getClientAccessInfo = async () => {
    const response = await fetch(`${CLOUDFLARE_CLIENT_ACCESS_URL}`)
    if (response.status !== 200) return

    const text = await response.text()
    const data: Record<string, string> = text
      .split('\n')
      .reduce<Record<string, string>>((acc: Record<string, string>, line: string) => {
        const [key, value] = line.split('=')
        if (key && value) {
          acc[key.trim()] = value.trim()
        }
        return acc
      }, {})

    setClientAccessInfo(data as ICloudflareTrace)
  }

  return {
    getClientAccessInfo,
  }
}
